import React from "react";
import Input from "../common/Input";
import Checkbox from "../common/Checkbox";
import Select from "../common/Select";

function MCRScreener({ data, handleChange, handleSave }) {
  return (
    <>
      <div className="row">
        <div className="ps-4 h3">Screener/Intake Interview</div>
      </div>
      <div className="row mb-4">
        <div className="col">
          <Input
            name="interviewDate"
            type="date"
            label="Date of Interview"
            onChange={handleChange}
            value={data.DynamicFields.results.interviewDate}
          />
        </div>
        <div className="col">
          <Input
            name="timeLengthOfInterview"
            label="Time of Interview and Interview Length"
            onChange={handleChange}
            value={data.DynamicFields.results.timeLengthOfInterview}
          />
        </div>
      </div>
      <div className="h4">Caregiver Information (If Applicable)</div>
      <div className="row">
        <div className="col">
          <Input
            name="caregiverLegalName"
            label="Caregiver Legal Name"
            onChange={handleChange}
            value={data.DynamicFields.results.caregiverLegalName}
          />
        </div>
        <div className="col">
          <Input
            name="caregiverPreferredName"
            label="Caregiver Preferred Name"
            onChange={handleChange}
            value={data.DynamicFields.results.caregiverPreferredName}
          />
        </div>
      </div>
      <div className="row mb-4">
        <div className="col">
          <Input
            name="caregiverBirthdate"
            type="date"
            label="Caregiver Date of Birth"
            onChange={handleChange}
            value={data.DynamicFields.results.caregiverBirthdate}
          />
        </div>
        <div className="col">
          <Input
            name="caregiverGenderPronouns"
            label="Caregiver Gender and Pronouns"
            onChange={handleChange}
            value={data.DynamicFields.results.caregiverGenderPronouns}
          />
        </div>
      </div>
      <div className="h4">Client Goals</div>
      <Input
        name="involvedInTreatment"
        label="Who will be involved in treatment (other providers, caregivers, etc.)"
        onChange={handleChange}
        value={data.DynamicFields.results.involvedInTreatment}
      />
      <Input
        name="clientStatedGoals"
        label="Client stated goals for the next 3-4 weeks"
        onChange={handleChange}
        value={data.DynamicFields.results.clientStatedGoals}
      />
      <Input
        name="clientStatedMotivation"
        label="Client stated motivation for achieving these goals"
        onChange={handleChange}
        value={data.DynamicFields.results.clientStatedMotivation}
      />
      <Select
        name="stageOfChange"
        label="Stage of Change"
        onChange={handleChange}
        value={data.DynamicFields.results.stageOfChange}
        options={[
          {
            name: "Precontemplation (Not yet considering change)",
            _id: "Precontemplation",
          },
          {
            name: "Contemplation (Sees the possibility of change)",
            _id: "Contemplation",
          },
          {
            name: "Determination (Committed to changing)",
            _id: "Determination",
          },
          { name: "Action (Taking steps toward change)", _id: "Action" },
          {
            name: "Maintenance (Has taken steps and is working to maintain change)",
            _id: "Maintenance",
          },
        ]}
      />
      <div className="ms-4 mb-4">
        <Checkbox
          name="previousReoccurrrence"
          label="Previous Reoccurrence? (has returned to previous stages)"
          onChange={handleChange}
          value={data.DynamicFields.results.previousReoccurrrence}
        />
      </div>
      <div className="h4">Possible Excluslusions</div>
      <div className="h6">Does the client have:</div>
      <div className="row mx-4">
        <div className="col">
          <Checkbox
            name="severeSubstanceUse"
            label="Severe Substance Use"
            onChange={handleChange}
            value={data.DynamicFields.results.severeSubstanceUse}
          />
        </div>
        <div className="col">
          <Checkbox
            name="psychoticBehaviors"
            label="Psychotic Behaviors"
            onChange={handleChange}
            value={data.DynamicFields.results.psychoticBehaviors}
          />
        </div>
        <div className="col mb-4">
          <Checkbox
            name="activeSiHi"
            label="Active SI/HI"
            onChange={handleChange}
            value={data.DynamicFields.results.activeSiHi}
          />
        </div>
      </div>
      <div className="mx-4">
        <Checkbox
          name="otherDisqualifyingBehaviors"
          label="Other disqualifying behaviors (lack of safety in home, etc.)"
          onChange={handleChange}
          value={data.DynamicFields.results.otherDisqualifyingBehaviors}
        />
      </div>
      {data &&
        data.DynamicFields &&
        data.DynamicFields.results &&
        data.DynamicFields.results.otherDisqualifyingBehaviors &&
        data.DynamicFields.results.otherDisqualifyingBehaviors === "true" && (
          <Input
            name="disqualifyingNarrative"
            label="Explain"
            onChange={handleChange}
            value={data.DynamicFields.results.disqualifyingNarrative}
          />
        )}
      <div className="mx-4">
        <Checkbox
          name="ableToMeet"
          label="Is the client willing/able to meet consistently for 3 weeks?"
          onChange={handleChange}
          value={data.DynamicFields.results.ableToMeet}
        />
      </div>
      <Input
        name="additionalInformation"
        label="Additional Information"
        onChange={handleChange}
        value={data.DynamicFields.results.additionalInformation}
      />
      <div className="h4 mt-4">Possible Respite Services</div>
      <div className="mx-4">
        <Checkbox
          name="supportClientsGoal"
          label="Support around Client's stated goal"
          onChange={handleChange}
          value={data.DynamicFields.results.supportClientsGoal}
        />
      </div>
      <Input
        name="otherPossibleSupportServices"
        label="Other possible support/services not mentioned"
        onChange={handleChange}
        value={data.DynamicFields.results.otherPossibleSupportServices}
      />
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default MCRScreener;
